<template>
  <div
    class="custom-notification-container"
    v-if="isAzureDeployment && constants && constants.pageSettings.showUrlMigrationNotification"
  >
    <mc-notification
      class="custom-notification"
      heading="Action required"
      body="GCD moved to a new URL. The current URL will stop working after 16 October."
      appearance="warning"
      icon="exclamation-triangle"
    >
      <span slot="actions" class="mc-notification__actions">
        <a class="mds-warning__text-color text-underlined" :href="getRedirectUri"
          >Switch to {{ getRedirectUri.replace(/^https?:\/\//, "").replace(/\/$/, "") }}</a
        >
      </span>
    </mc-notification>
  </div>
</template>

<script>
import "@maersk-global/mds-components-core/mc-notification";
import { getCurrentEnvironmentVariables, constants } from "@/lib/CONSTANTS";

export default {
  name: "UrlMigrationNotification",
  data() {
    return {
      constants
    };
  },
  computed: {
    isAzureDeployment() {
      // Check if window is available (browser environment)
      if (typeof window !== "undefined" && window.location) {
        const currentHost = window.location.hostname;

        // Check if it's an Azure deployment (azurewebsites.net or its subdomains)
        if (currentHost === "azurewebsites.net" || currentHost.endsWith(".azurewebsites.net")) {
          return true;
        }
      }

      // Use the current environment configuration for other deployments
      return false;
    },
    getRedirectUri() {
      // Use the current environment configuration for other deployments
      return getCurrentEnvironmentVariables().redirectUri;
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.custom-notification-container {
  max-width: 1280px;
  margin: 0 auto;
}
.custom-notification {
  width: 50%;
  display: block;
  padding: 12px 0px;
}
</style>
